import { render, staticRenderFns } from "./profile-general.vue?vue&type=template&id=8e5a4de0&scoped=true"
import script from "./profile-general.vue?vue&type=script&lang=js"
export * from "./profile-general.vue?vue&type=script&lang=js"
import style0 from "./profile-general.vue?vue&type=style&index=0&id=8e5a4de0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5a4de0",
  null
  
)

export default component.exports